export default __webpack_public_path__ + "static/media/Markers_Yellow Marker.ef3e0a01.svg";